import { MedplumClient } from "@medplum/core";
import fetchResourceIcon from "../../assets/img/fetchingResourceLogo.svg";
import dbStoringIcon from "../../assets/img/storingDBLogo.svg";

export async function hl7Bot(medplum: MedplumClient, payload: any) {
  try {
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "hl7",
      },
      payload,
      "text/plain"
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
    return
  }
}
export async function generateHl7MessageBot(medplum: MedplumClient, payload: any) {
  try {
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "hl7-samples",
      },
      payload,
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
    return
  }
}

 export const modalSteps = [
   {
     loadText: "Incoming HL7 trigger message",
     label: "Incoming HL7 trigger message",
     icon: fetchResourceIcon,
   },
   {
     loadText: "Listening to HL7 messages",
     label: "Listening to HL7 messages",
     icon: fetchResourceIcon,
   },
   {
     loadText: "Connection establised",
     label: "Connection establised",
     icon: dbStoringIcon,
   },
   {
     loadText: "Converting HL7 to FHIR",
     label: "Converting HL7 to FHIR",
     icon: dbStoringIcon,
   },
 ];

 export const data = [
   {
     label: "HL7 ORU (Observation Result)",
     value: "ORU",
   },
   {
     label: "HL7 ADT (Admit, Discharge, and Transfer)",
     value: "ADT",
   },
   {
     label: "HL7 SIU (Scheduling Information Unsolicited)",
     value: "SIU",
   },
   {
     label: "HL7 ORM (Order Entry)",
     value: "ORM",
   },

   {
     label: "HL7 MDM (Medical Document Management)",
     value: "MDM",
   },
   {
     label: "HL7 DFT (Detailed Financial Transactions)",
     value: "DFT",
   },
   {
     label: "HL7 BAR (Billing Account Record)",
     value: "BAR",
   },
   {
     label: "HL7 RDE (Pharmacy/Treatment Encoded Order)",
     value: "RDE",
   },
   {
     label: "HL7 ACK (Acknowledgement Message)",
     value: "ACK",
   },
 ];